
export default {
  name: "Blog404",

  head() {
    return {
      title: this.$t('blog.errorPage.meta.title') || this.$t('page_meta.home.title'),
      meta: [
        {
          hid: 'og:title', name: 'og:title', property: 'og:title',
          content: this.$t('blog.errorPage.meta.title') || this.$t('page_meta.home.title'),
        },
        {
          hid: 'og:description', name: 'og:description', property: 'og:description',
          content: this.$t('blog.errorPage.meta.description') || this.$t('page_meta.home.description'),
        },
        {
          hid: 'description', name: 'description',
          content: this.$t('blog.errorPage.meta.description') || this.$t('page_meta.home.description'),
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ]
    }
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    }
  }
}
